import { useEffect, useRef } from 'react';
import { useProfileQuery } from '@/features/settings/profile-api';
import { useUIStore } from '@/lib/store';

/*
 * useServerLocaleSync (kielipersistointikorjaus 18.7.2026).
 *
 * Soveltaa palvelimelle tallennetun kielivalinnan (users.locale, GET /api/me/profile)
 * UI-storeen KERRAN per sovelluslataus. Nain kielivalinta seuraa kayttajaa laitteelta
 * toiselle: jokainen kielenvaihto PATCHaa serverin (LanguageSwitcher/ProfileTab), joten
 * server on aina tuorein lahde sovelluksen kaynnistyessa.
 *
 * Kerran-per-mount-vahti estaa sen, etta profiilikyselyn refetch myohemmin kumoaisi
 * kayttajan juuri tekeman paikallisen vaihdon (PATCH voi olla viela matkalla).
 */
export function useServerLocaleSync() {
  const { data } = useProfileQuery();
  const setLocale = useUIStore((s) => s.setLocale);
  const applied = useRef(false);

  useEffect(() => {
    if (applied.current) return;
    const serverLocale = data?.locale;
    if (serverLocale !== 'fi' && serverLocale !== 'en') return;
    applied.current = true;
    if (useUIStore.getState().locale !== serverLocale) {
      setLocale(serverLocale);
    }
  }, [data?.locale, setLocale]);
}
